module.exports = __webpack_public_path__ + "static/dom-6bc80600eaf0bde39f33603a01c3634a.png";